import { createFileRoute } from "@tanstack/react-router";
import { CohortSettingsScreen } from "@modules/cohorts/views";

export const Route = createFileRoute("/_staff-area/cohorts/$cohortId/settings")(
  {
    staticData: { title: "nav.settings", crumb: "nav.settings" },
    component: SettingsRoute,
  }
);

function SettingsRoute() {
  const { cohortId } = Route.useParams();
  return <CohortSettingsScreen cohortId={cohortId} />;
}
